import template from './bagout.html';
import controller from './bagout.controller';
import './bagout.scss';

let bagoutComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default bagoutComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/bagout/bagout.component.js